import { render, staticRenderFns } from "./EmployerDesc.vue?vue&type=template&id=2cc51f6f&scoped=true&"
import script from "./EmployerDesc.vue?vue&type=script&lang=js&"
export * from "./EmployerDesc.vue?vue&type=script&lang=js&"
import style0 from "./EmployerDesc.vue?vue&type=style&index=0&id=2cc51f6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc51f6f",
  null
  
)

export default component.exports